module.exports = {
  props: ['message', 'isopen', 'translation'],
  data () {
    return {
      timer: null
    }
  },
  watch: {
    isopen (newValue) {
      if (newValue) {
        this.startTimer(7000)
      } else {
        this.clearTimer()
      }
    }
  },
  methods: {
    startTimer (duration) {
      this.timer = setTimeout(() => {
        this.close()
      }, duration)
    },

    clearTimer () {
      clearTimeout(this.timer)
    },

    close () {
      this.$emit('update:isopen', false)
    }
  },
  template:`
    <transition name="notification">
      <div v-if="isopen" class="notification text-left">
        <span @click="close"><i class="icon-close h-pointer notification__icon-close"></i></span>
        <i class="icon-cancel notification__icon"></i>
        <h5 class="notification__title">{{translation['Error']}}</h5>
        <div class="notification__desc h-text-grey-cl-400">{{ message }}</div>
      </div>
    </transition>
  `
}